import { blobToBase64 } from "../utils/blobToBase64";
import { callFirebaseCallable } from "./recordingFirebaseAuth";

type StartRecordingRetailRequest = {
  chunkSeconds: number;
  mimeType: string;
  shiftDate: string;
};

type StartRecordingResponse = {
  recordingId: string;
};

type BatchUploadRequest = {
  chunkIndexToAudioBase64: Record<string, string>;
  recordingId: string;
};

type BatchUploadResponse = {
  success: boolean;
};

type CompleteRecordingRequest = {
  expectedFinalChunkIndex: number;
  recordingId: string;
};

type CompleteRecordingResponse = {
  success: boolean;
};

const startRecording = async (
  shiftDate: string,
  mimeType: string,
  chunkSeconds: number,
  hybridToken: string
): Promise<StartRecordingResponse> => {
  return callFirebaseCallable<
    StartRecordingRetailRequest,
    StartRecordingResponse
  >(
    "start_recording_retail",
    {
      shiftDate,
      mimeType,
      chunkSeconds,
    },
    hybridToken
  );
};

const batchUploadChunks = async (
  recordingId: string,
  chunks: Array<{ chunkIndex: number; blob: Blob }>,
  hybridToken: string
): Promise<void> => {
  const encoded = await Promise.all(
    chunks.map(async ({ chunkIndex, blob }) => ({
      chunkIndex,
      audioBase64: await blobToBase64(blob),
    }))
  );

  const chunkIndexToAudioBase64 = encoded.reduce<Record<string, string>>(
    (map, { chunkIndex, audioBase64 }) => {
      map[String(chunkIndex)] = audioBase64;
      return map;
    },
    {}
  );

  await callFirebaseCallable<BatchUploadRequest, BatchUploadResponse>(
    "batch_upload",
    {
      recordingId,
      chunkIndexToAudioBase64,
    },
    hybridToken
  );
};

const completeRecording = async (
  recordingId: string,
  expectedFinalChunkIndex: number,
  hybridToken: string
): Promise<void> => {
  await callFirebaseCallable<
    CompleteRecordingRequest,
    CompleteRecordingResponse
  >(
    "complete_recording",
    {
      recordingId,
      expectedFinalChunkIndex,
    },
    hybridToken
  );
};

export { batchUploadChunks, completeRecording, startRecording };
export type {
  BatchUploadResponse,
  CompleteRecordingResponse,
  StartRecordingResponse,
};
